import * as React from 'react';
import { FixMeLater } from '../../../utils';

export interface ModularPriceMajorProps {
    /**
     * The price's major Digits
     */
    children?: string;
}

export const ModularPriceMajor: React.ForwardRefExoticComponent<
    ModularPriceMajorProps & React.RefAttributes<HTMLElement>
> = React.forwardRef(function ModularPriceMajor(
    props: ModularPriceMajorProps,
    ref: React.ForwardedRef<FixMeLater>
): React.JSX.Element {
    const { children, ...other } = props;
    return (
        <span ref={ref} data-major={true} {...other}>
            {children}
        </span>
    );
});
